import React, { useState } from 'react';
import {
    Box,
    VStack,
    HStack,
    Text,
    Button,
    Divider,
    useBreakpointValue,
    Container
} from '@chakra-ui/react';
import { MdUpload, MdLibraryBooks } from 'react-icons/md';
import DocumentUpload from './DocumentUpload';
import DocumentList from './DocumentList';
import DocumentEditor from './DocumentEditor';

const DocumentLibrary = () => {
    const [showUpload, setShowUpload] = useState(false);
    const [editingDocument, setEditingDocument] = useState(null);
    const isMobile = useBreakpointValue({ base: true, md: false });

    const handleUploadComplete = () => {
        setShowUpload(false);
    };

    const handleEditDocument = (document) => {
        setEditingDocument(document);
    };

    const handleCloseEditor = () => {
        setEditingDocument(null);
    };

    return (
        <Container maxW="6xl" py={{ base: 4, md: 8 }}>
            <VStack spacing={{ base: 6, md: 8 }} align="stretch">
                {/* Header */}
                <VStack spacing={4} align="stretch">
                    <HStack justify="space-between" align="center">
                        <HStack spacing={3}>
                            <MdLibraryBooks size="28px" color="brand.500" />
                            <VStack align="flex-start" spacing={0}>
                                <Text fontSize={{ base: "xl", md: "2xl" }} fontWeight="600">
                                    Document Library
                                </Text>
                                <Text fontSize="sm" color="gray.600">
                                    Upload PDFs for OCR processing and text editing
                                </Text>
                            </VStack>
                        </HStack>

                        <Button
                            leftIcon={<MdUpload />}
                            colorScheme="brand"
                            onClick={() => setShowUpload(!showUpload)}
                            size={isMobile ? "sm" : "md"}
                        >
                            {showUpload ? 'Cancel' : 'Upload PDF'}
                        </Button>
                    </HStack>

                    {/* Upload Section */}
                    {showUpload && (
                        <>
                            <Divider />
                            <DocumentUpload onUploadComplete={handleUploadComplete} />
                        </>
                    )}
                </VStack>

                <Divider />

                {/* Documents List */}
                <Box>
                    <DocumentList onEditDocument={handleEditDocument} />
                </Box>
            </VStack>

            {/* Document Editor Modal */}
            <DocumentEditor
                isOpen={!!editingDocument}
                onClose={handleCloseEditor}
                document={editingDocument}
            />
        </Container>
    );
};

export default DocumentLibrary;